
import React from 'react';
import ViewHome from './home/ViewHome';
import ViewGalleryLocationLifestyle from './location-lifestyle/ViewGalleryLocationLifestyle';
import ViewMap from './map/ViewMap';
import { locationlifestyle1, locationlifestyle2, locationlifestyle3, locationlifestyle4, locationlifestyle5, locationlifestyle6, locationlifestyle7, locationlifestyle8, locationlifestyle9, locationlifestyle10, amenities, building, team1, team2, design1, design2, design3, design4, design5, design6, design7, design8, design9, design10, design11, design12, design13, design14, design15, interiorsImages1, interiorsImages2, interiorsImages3, interiorsImages4, interiorsImages5, interiorsImages6, interiorsImages7, interiorsImages8, interiorsImages9, interiorsFinishes1, interiorsFinishes2, interiorsFinishes3, interiorsFinishes4, interiorsFinishes5, interiorsDetail1, interiorsDetail2, interiorsDetail3, interiorsDetail4, interiorsDetail5, interiorsDetail6, interiorsDetail7, interiorsDetail8, interiorsDetail9, interiorsDetail10, interiorsDetail11, interiorsDetail12, interiorsDetail13, interiorsDetail14, interiorsDetail15, aerial, interiors, finishes, interiors2, building2, building3} from './gallery/data/gallery';
import ViewInteriorsImages from './interiors-images/ViewInteriorsImages';
import ViewInteriorsFinishes from './interiors-finishes/ViewInteriorsFinishes';
import ViewInteriorsDetail from './interiors-detail/ViewInteriorsDetail';
import ViewGalleryElevations from './elevations/ViewGalleryElevations'
import ViewGalleryTeam from './team/ViewGalleryTeam';
import ViewGalleryBuilding from './gallery-building/ViewGalleryBuilding';
import ViewGalleryAmenities from './gallery-amenities/ViewGalleryAmenities';
import ViewGalleryFlythrough from './gallery-fly-through/ViewGalleryFlythrough';
import ViewGalleryDesign from './design/ViewGalleryDesign';
import ViewMovies from './movies/ViewMovies';
import ViewImage from '../app/components/viewImage/ViewImage';
import ViewAmenities from './amenities/ViewAmenities';
import { data as dataAmenities } from './amenities/dataAmenities';
import ViewGalleryInteriors from './gallery-interiors/ViewGalleryInteriors';
import ViewVirtualTour from './tour/ViewVirtualTour';
import ViewGallery from './gallery/ViewGallery';
import { dataInteriors } from './color-scheme/dataGallery';
import ConnectViewGallery from './color-scheme/ConnectViewGallery';
import ViewResidences from './residences/ViewResidences';

export const dataRoutes = [
    {
        title: 'Team',
        path: '/team',
        component: ViewGalleryTeam,
        data: [team1],
    },
        {
        title: 'Location',
        routes: [
            {
                title: 'Aerial',
                path: '/location-aerial',
                component: ViewGalleryLocationLifestyle,
                data: [aerial],
            },
            {
                title: 'Lifestyle',
                path: '/location-lifestyle',
                component: ViewGalleryLocationLifestyle,
                data: [locationlifestyle1, locationlifestyle2, locationlifestyle3, locationlifestyle4, locationlifestyle5, locationlifestyle6, locationlifestyle7, locationlifestyle8, locationlifestyle9, locationlifestyle10],
            },
            {

                title: 'Map',
                path: '/location-map',
                component: ViewMap,

            },
        ]
    },
    {
        title: 'Design',
        path: '/design',
        component: ViewGalleryDesign,
        data: [design1, design2, design3, design4 ,design5 ,design6]
    },
    {
        title: 'Interiors',
        routes: [
            {
                title: 'Detail',
                path: '/detail',
                component: ViewInteriorsImages,
                data: [interiorsDetail1, interiorsDetail2, interiorsDetail3, interiorsDetail4, interiorsDetail5, interiorsDetail6, interiorsDetail7, interiorsDetail8, interiorsDetail9, interiorsDetail10, interiorsDetail11, interiorsDetail12, interiorsDetail13, interiorsDetail14, interiorsDetail15],
            },

            {
                title: 'Virtual Tour',
                path: '/vr-tour-1',
                component: ViewVirtualTour,
            },
        ]
    },
    {
        title: 'Residences',
        path: '/residences',
        component: ViewResidences,

    },
    {
        title: 'Gallery',
        routes: [
            {
                title: 'Building',
                path: '/gallery-building',
                component: ViewGalleryBuilding,
                data: [building, building2, building3],
            },
            {
                title: 'Video',
                path: '/gallery-flythrough',
                component: ViewMovies,
            },

        ]
    },
    {
        title: 'Home',
        path: '/',
        component: ViewHome
    }

];